import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MessageService } from '../../../../../core/services/messages/messages.service';
import { widgetType } from '../../../../../constants/widget-type.constants';
import { languages } from '../../../../../constants/language.constants';
import { ViewportService } from '@shared/common/services/viewport/viewport.service';
import { IGuestsData } from '../../../../../core/interfaces/guests-data';

@Component({
  selector: 'app-widget-params',
  templateUrl: './widget-params.component.html',
  styleUrls: ['./widget-params.component.scss'],
  standalone: false
})
export class WidgetParamsComponent implements OnInit {
  isCalendarVisible = false;
  widgetType = widgetType;

  @Input() dataFetched: boolean;
  @Input() selectedDatesLabel: string;
  @Input() selectedDates: [Date];
  @Input() adults: number;
  @Input() rooms: number;
  @Input() openGuestPickerModalOnMobile: boolean;
  @Input() childrenAges: string;
  @Input() isFetching: boolean;
  @Input() updateGuestWithoutRequest: boolean;
  @Input() cancellationVars: string[];
  @Input() watchIndex: number;
  @Input() cityId: number;
  @Input() propertyId: number;
  @Input() unitGroupId: number;
  @Input() checkin: string;
  @Input() checkout: string;
  @Input() widgetSpecifiedType: widgetType;
  @Input() classList: string;
  @Input() isEmptyDates: boolean;
  @Input() currentLang: languages;
  @Input() isExtension: boolean;
  @Input() readOnly: boolean;
  @Input() guestCtaText: string;
  @Input() calendarType: 'pdp' | 'listing' | 'other';
  @Output() bookedDates: EventEmitter<Date[]> = new EventEmitter();
  @Output() guestsData: EventEmitter<IGuestsData> = new EventEmitter();
  @Output() selectedCancellation: EventEmitter<number> = new EventEmitter();
  @Output() widgetPickersOpeningStatus: EventEmitter<boolean> = new EventEmitter();
  @Output() datePickersOpeningStatus: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private readonly messagingService: MessageService,
    public viewportService: ViewportService
  ) {}

  ngOnInit() {}

  showHideCalendar(ev: boolean): void {
    if (!this.isExtension) {
      this.isCalendarVisible = ev;
      this.datePickersOpeningStatus.emit(ev);
      this.messagingService.updateOverlayStatus(
        this.isCalendarVisible,
        this.isCalendarVisible,
        this.viewportService.isTabletDevice()
      );
    }
  }

  updateBookedDates(dates: Date[]): void {
    this.showHideCalendar(false);
    this.bookedDates.emit(dates);
  }

  updateGuestsData(data: IGuestsData): void {
    this.guestsData.emit(data);
  }
  onGuestDropdownStatus(status: boolean) {
    this.widgetPickersOpeningStatus.emit(status);
  }
}
